/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Cmp_About_OverlineInputs */

const en_cmp_about_overline = /** @type {(inputs: Cmp_About_OverlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What ${i?.name} is`)
};

const id_cmp_about_overline = /** @type {(inputs: Cmp_About_OverlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apa itu ${i?.name}`)
};

/**
* | output |
* | --- |
* | "What {name} is" |
*
* @param {Cmp_About_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_about_overline = /** @type {((inputs: Cmp_About_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_About_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_about_overline(inputs)
	return en_cmp_about_overline(inputs)
});